export default "__VITE_ASSET__CpwVmwV$__"